// The single list of languages Lopaka is available in. Adding a language is a
// dictionary in ./messages plus an entry here.
// Keep this folder's plain modules free of DOM, Node, and Vue imports: the
// Cloudflare Workers build (middleware, page metadata) imports them too.

// `flag` is the emoji shown next to the two-letter code in the compact switcher.
export const LOCALES = [
    {code: 'en', nativeName: 'English', flag: '🇬🇧', hreflang: 'en', ogLocale: 'en_US'},
    {code: 'es', nativeName: 'Español', flag: '🇪🇸', hreflang: 'es', ogLocale: 'es_LA'},
    {code: 'de', nativeName: 'Deutsch', flag: '🇩🇪', hreflang: 'de', ogLocale: 'de_DE'},
] as const;

export type Locale = (typeof LOCALES)[number]['code'];

/** Served without a URL prefix and used when nothing else matches. */
export const DEFAULT_LOCALE: Locale = 'en';

export const LOCALE_CODES: readonly Locale[] = LOCALES.map((locale) => locale.code);

export function isLocale(value: unknown): value is Locale {
    return LOCALE_CODES.includes(value as Locale);
}

/**
 * The Open Graph `og:locale` of a page language, then `og:locale:alternate` for every
 * other language the page is available in (all languages unless `available` says otherwise).
 */
export function ogLocaleTags(
    locale: Locale,
    available: readonly Locale[] = LOCALE_CODES,
): {property: 'og:locale' | 'og:locale:alternate'; content: string}[] {
    return [
        ...LOCALES.filter((entry) => entry.code === locale).map((entry) => ({
            property: 'og:locale' as const,
            content: entry.ogLocale,
        })),
        ...LOCALES.filter((entry) => entry.code !== locale && available.includes(entry.code)).map((entry) => ({
            property: 'og:locale:alternate' as const,
            content: entry.ogLocale,
        })),
    ];
}
